var $a59a67776704c670$exports = {};
$a59a67776704c670$exports = {
    "collectionLabel": `N\xe1vrhy`
};


export {$a59a67776704c670$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
